<script setup>
  import SkeletonLoader from "@components/SkeletonLoader.vue";

  defineOptions({
    name: "LaborValueSkeletonRowMainValues",
  });
</script>

<template>
  <li class="grid animate-pulse grid-cols-12 gap-x-6 border-gray-300 p-2" :data-test="getTestId('skeleton')">
    <div class="col-span-2 h-[75px]">
      <SkeletonLoader class-names="m-1 w-1/2 h-[17px]" />
      <SkeletonLoader class-names="m-1 w-full h-[35px]" />
    </div>

    <div class="col-span-3 h-[75px]">
      <SkeletonLoader class-names="m-1 w-1/2 h-[17px]" />
      <SkeletonLoader class-names="m-1 w-full h-[35px]" />
    </div>

    <div class="col-span-2 h-[75px]">
      <SkeletonLoader class-names="m-1 w-1/2 h-[17px]" />
      <SkeletonLoader class-names="m-1 w-full h-[35px]" />
    </div>

    <div class="col-span-3 h-[75px]">
      <SkeletonLoader class-names="m-1 w-1/2 h-[17px]" />
      <SkeletonLoader class-names="m-1 w-full h-[35px]" />
    </div>

    <div class="col-span-2 h-[75px]">
      <SkeletonLoader class-names="m-1 w-1/2 h-[17px]" />
      <SkeletonLoader class-names="m-1 w-full h-[35px]" />
    </div>
  </li>
</template>
